export function getSavedState(key) {
  try {
    return JSON.parse(window.localStorage.getItem(key));
  } catch (e) {
    return false;
  }
}

export function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state));
}
